export const GRADE_TYPES = ['default'] as const;
export type GradeType = (typeof GRADE_TYPES)[number];

export const GRADE_SCALE = [1, 2, 3, 4, 5] as const;
export type GradeValue = (typeof GRADE_SCALE)[number];
